import { VehicleType } from "@daytrip/legacy-enums";
import { Exclude, Expose, Type } from "class-transformer";
import { IsDate, IsDefined, IsNumber, IsUUID } from "class-validator";

@Exclude()
export class HeatmapOutput {
    @IsUUID("4")
    @IsDefined()
    @Expose()
    public movementLocation: string;

    @IsDate()
    @IsDefined()
    @Expose()
    @Type(() => Date)
    public departureAt1: Date;

    @IsNumber()
    @IsDefined()
    @Expose()
    @Type(() => Number)
    public vehicle: VehicleType;

    @IsNumber()
    @IsDefined()
    @Expose()
    public latitude: number;

    @IsNumber()
    @IsDefined()
    @Expose()
    public longitude: number;
}
